var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('input',_vm._g(_vm._b({staticClass:"form-control",attrs:{"id":_vm.id,"type":_vm.type},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.inputListeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }